import React from 'react';

import CopyLink from './CopyLink';
import ButtonCollection from './ButtonCollection';
import FloatingLayer from './FloatingLayer';
import SectionTitle from './SectionTitle';

const RawDataViewerWrapper = (props) => {
	const scroll_enabled = props?.scroll_enabled ?? true;

	const classes = ['gui_json_viewer'];
	if(scroll_enabled) classes.push('gui_overflowed_auto');

	return (
		<div class={classes.join(" ")}>
			<pre class="in_top in_bottom">
				<code class="is_monospaced">
					{props.children}
				</code>
			</pre>
		</div>
	)
};

const JSONObjectLevel = ({ data, level = 0, ...props }) => {
	const ul_classes = (level < 1) ? 'outter_level' : `inner_level level_${level}`;

	if(data == undefined) return null;

	return (
		<ul class={ul_classes}>
			{Object.entries(data).map(([key, value]) => {
				if(typeof value === 'string' || value == undefined) {
					return (
						<li key={key}>
							<span>{key}: </span>
							<strong>"{value}"</strong>
						</li>
					)
				}

				if(typeof value === 'number') {
					return (
						<li key={key}>
							<span>{key}: </span>
							<strong>{value}</strong>
						</li>
					)
				}

				if(Array.isArray(value)) {
					return (
						<li key={key}>
							<span>{key}: </span>

							{value.map((item, i) => {
								return (
									<ul key={`${key}_${i}`} class={`inner_level level_${level + 1} in_array`}>
										<li>
											<span>Item #{i + 1}: </span>

											{(typeof(item) == 'string') && (
												<strong>"{item}"</strong>
											)}

											{(typeof(item) == 'number') && (
												<strong>{item}</strong>
											)}

											{(typeof(item) != 'string' && typeof(item) != 'number') && (
												<JSONObjectLevel
													data={item}
													level={level + 2}
												/>
											)}
										</li>
									</ul>
								)
							})}
						</li>
					)
				}

				return (
					<li key={key}>
						<span>{key}: </span>

						<JSONObjectLevel
							data={value}
							level={level + 1}
						/>
					</li>
				)
			})}
		</ul>
	)
};

export const PrettyFormattedData = ({ raw_data, ...props }) => {
	if(raw_data == undefined || raw_data == '') return null;

	return (
		<RawDataViewerWrapper
			scroll_enabled={props.scroll_enabled}
		>
			<JSONObjectLevel
				data={JSON.parse(raw_data)}
				level={0}
			/>
		</RawDataViewerWrapper>
	)
};

export const __PrettyFormattedData = ({ raw_data, ...props }) => {
	if(raw_data == undefined || raw_data == '') return null;

	return (
		<RawDataViewerWrapper
			scroll_enabled={props.scroll_enabled}
		>
			<ul class="outer_level">
				{Object.entries(JSON.parse(raw_data)).map(([key, value]) => {
					if(typeof value === 'string') {
						return (
							<li key={key}>
								<span>{key}:</span> <strong>{value}</strong>
							</li>
						)
					}

					return (
						<li key={key}>
							<span>{key}:</span>

							<ul class="inner_level">
								{Object.entries(value).map(([subkey, subvalue]) => {
									return (
										<li key={subkey}>
											{subkey}: <strong>{subvalue}</strong>
										</li>
									)
								})}
							</ul>
						</li>
					)
				})}
			</ul>
		</RawDataViewerWrapper>
	)
};

const RawDataViewer = (props) => {
	if(props.raw_data == undefined) return null;
	const formatted_data = JSON.stringify(props.raw_data, null, 2);

	const is_standalone = props?.is_standalone ?? false;

	if(is_standalone) {
		return (
			<RawDataViewerWrapper
				scroll_enabled={props.scroll_enabled}
			>{formatted_data}</RawDataViewerWrapper>
		)
	}

	return (
		<FloatingLayer backButton={props.close}>
			<div>
				<SectionTitle>RAW data</SectionTitle>

				<RawDataViewerWrapper
					scroll_enabled={props.scroll_enabled}
				>{formatted_data}</RawDataViewerWrapper>

				<ButtonCollection in_floating={true}>
					<CopyLink type='submit' copy_link={formatted_data}>Copy</CopyLink>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}

export default RawDataViewer;